/**
 * BadgeNoti의 badgeContent가 99 이상일 때 99+로 표시
 * @param badgeContent
 */
export default function getBadgeContent(badgeContent: number) {
  return badgeContent > 99 ? '99+' : badgeContent;
}
